import React from "react";
import PropTypes from "prop-types";
import ENV from "app/utils/ENV";
import { View, TextInput } from "react-native";
import { styleSheet, colors, sizes } from "app/utils/styleSheet";
import TouchableWithoutFeedback from "app/components/TouchableWithoutFeedback";
import TouchableOpacity from "app/components/TouchableOpacity";
import keyboardHelpers from "app/utils/keyboardHelpers";
import Text from "app/components/Text";
import store from "app/redux/store";

import { StyleContext } from "app/contexts/Style";

export default class CustomTextInput extends React.Component {
  static contextType = StyleContext;
  static propTypes = {
    bold: PropTypes.bool,
    medium: PropTypes.bool,
    light: PropTypes.bool,
    hidden: PropTypes.bool,
    italic: PropTypes.bool,
    strike: PropTypes.bool,
    // style
  };

  constructor(props) {
    super(props);
    this.state = {
      height: null,
      width: null,
      // focused: props.autoFocus,
      focused: false,
      shift: false,
      meta: false,
      nativeSelection: undefined,
    };
  }

  componentDidMount() {
    if (this.props.autoHeight) this.applyAutoHeight();
    if (ENV.WEB) {
      document.addEventListener("keyup", this.handleKeyUp);
      // document.addEventListener("keydown", this.handleKeyDown);
    }

    // if (this.props.preventScrollTo) {
    //   console.log(this.ref, this.ref?.current);
    //   this.ref?.addEventListener("focus", (e) => {
    //     console.log("prevent focus scroll?");
    //     e.preventDefault();
    //   });
    //   this.ref?.addEventListener("focusin", (e) => {
    //     console.log("prevent focusin scroll?");
    //     e.preventDefault();
    //   });
    // }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.autoHeight != this.props.autoHeight) {
      if (this.props.autoHeight) {
        this.applyAutoHeight();
        if (ENV.WEB) this.ref.focus();
      }
    }
  }

  componentWillUnmount() {
    if (ENV.WEB) {
      document.removeEventListener("keyup", this.handleKeyUp);
      document.removeEventListener("keydown", this.handleKeyDown);
    }
    this.unsubscribeRedux && this.unsubscribeRedux();
  }

  subscribe = () => {
    if (!!this.unsubscribeRedux) this.unsubscribeRedux();
    console.log("textinput subscribing");
    let { listeners } = store.getState();
    this.lastEventTimestamp = listeners.timestamp;
    this.unsubscribeRedux = store.subscribe(() => {
      // Only handle events if this input is focused
      if (!this.state.focused) return;

      // Prevent re-entrant calls
      if (this.handlingReduxEvent) return;

      let { listeners } = store.getState();
      if (listeners.timestamp != this.lastEventTimestamp) {
        this.lastEventTimestamp = listeners.timestamp;
        this.handlingReduxEvent = true;

        try {
          console.log("TextInput handling event:", listeners.event);
          if (listeners.event == "arrow_down") {
            this.handleKeyPress({
              key: "ArrowDown",
              nativeEvent: { key: "ArrowDown" },
              preventDefault: () => null,
              stopPropagation: () => null,
            });
          } else if (listeners.event == "arrow_up") {
            this.handleKeyPress({
              key: "ArrowUp",
              nativeEvent: { key: "ArrowUp" },
              preventDefault: () => null,
              stopPropagation: () => null,
            });
          } else if (listeners.event == "tab") {
            this.handleKeyPress({
              key: "Tab",
              nativeEvent: { key: "Tab" },
              preventDefault: () => null,
              stopPropagation: () => null,
            });
          } else if (listeners.event.startsWith("meta_")) {
            let key = listeners.event.split("_")[1].toLowerCase();
            this.handleKeyPress({
              nativeEvent: { key, metaKey: true },
              key,
              metaKey: true,
              preventDefault: () => null,
              stopPropagation: () => null,
            });
          }
        } finally {
          this.handlingReduxEvent = false;
        }
      }
    });
  };

  handleKeyUp = (e) => {
    if (this.state.focused) {
      if (e.key == "Meta") {
        this.setState({ meta: false });
        this.props.onSetMeta && this.props.onSetMeta(false);
      } else if (e.key == "Shift") {
        this.setState({ shift: false });
        this.props.onSetShift && this.props.onSetShift(false);
      }
    }
    this.setCaret();
  };

  handleKeyDown = (e) => {
    if (this.state.focused) {
      if (e.key == "Meta") {
        this.setState({ meta: true });
        this.props.onSetMeta && this.props.onSetMeta(true);
      } else if (e.key == "Shift") {
        this.setState({ shift: true });
        this.props.onSetShift && this.props.onSetShift(true);
      }
    }
  };

  onChangeText = (text) => {
    this.props.onChangeText(text);
  };

  render() {
    let { style, autoHeight, autoWidth, wrapperStyle, keyboardAccType } =
      this.props;
    let { height, width } = this.state;
    let styleArray = [];
    if (style && Array.isArray(style)) {
      styleArray = style;
    } else {
      styleArray = [style];
    }

    let formattedStyle = this.formatStyle();

    // if (autoHeight && !!height) {
    if (autoHeight) {
      let minHeight = ENV.WEB ? 4 : this.context.sizes.default * 2.5;
      height = height || minHeight;
      minHeight = Math.max(height, minHeight);
      styleArray = [
        ...styleArray,
        {
          height,
          minHeight,
          overflow: "hidden",
        },
      ];
    }
    if (autoWidth && !!width) {
      styleArray = [
        ...styleArray,
        { width, minWidth: width, overflow: "hidden" },
      ];
    }

    let { children, value, onPress, onLongPress, ...safeProps } = this.props;

    let val =
      !!children || children === 0
        ? children
        : !!value || value === 0
        ? value
        : "";
    let stringVal = val != null ? String(val) : "";
    this.stringVal = stringVal;

    let nativeSel = this.state.nativeSelection;
    let safeSelection =
      !ENV.WEB && nativeSel
        ? {
            start: Math.min(nativeSel.start, stringVal.length),
            end: Math.min(nativeSel.end, stringVal.length),
          }
        : undefined;

    return (
      <View style={[{ flex: 1 }, wrapperStyle]}>
        <TouchableOpacity
          ref={(r) => (this.touchableRef = r)}
          onPress={onPress}
          onLongPress={onLongPress}
        >
          <TextInput
            placeholderTextColor={
              this.props.placeholderTextColor || this.context.colors.trim
            }
            {...safeProps}
            nativeID={this.getNativeId()}
            value={stringVal}
            selection={safeSelection}
            onFocus={() => {
              this.touchableRef?.cancelPress();
              this.setState({ focused: true });
              this.props.onFocus && this.props.onFocus();
              this.subscribe();
              if (!!keyboardAccType) {
                console.warn("setting", keyboardAccType);
                this.context.setContext("keyboardAccType", keyboardAccType);
              }
            }}
            onBlur={() => {
              this.setState({ focused: false });
              this.props.onBlur && this.props.onBlur();
              this.unsubscribeRedux && this.unsubscribeRedux();
            }}
            onKeyPress={(e) => this.handleKeyPress(e, stringVal)}
            // selectionColor={"rgba(255, 0, 0, 1)"}
            onSelectionChange={(e) => {
              !!this.props.onSelectionChange && this.props.onSelectionChange(e);
              if (!ENV.WEB) {
                let { start, end } = e.nativeEvent?.selection;
                this.setState({ nativeSelection: { start, end } });
                if (start != end) {
                  let selectedText = stringVal.slice(start, end);
                  this.context.setContext("selectedText", selectedText);
                  this.context.setContext("selection", [start, end]);
                } else {
                  this.context.setContext("selectedText", null);
                  this.context.setContext("selection", null);
                }
              }
            }}
            // caretColor={"#0ff"}
            style={[formattedStyle, ...styleArray]}
            // ref={this.props.inputRef}
            ref={(c) => {
              // console.log(c);
              if (this.props.inputRef) {
                this.props.inputRef(c);
              }
              return (this.ref = c);
            }}
            onContentSizeChange={(event) => {
              // console.log("onContentSizeChange", event);
              if (autoHeight)
                this.applyAutoHeight(event.nativeEvent.contentSize.height);
              if (autoWidth) this.applyAutoWidth();
            }}
          />
        </TouchableOpacity>
        {autoWidth && (
          <View
            ref={(r) => (this.shadowRef = r)}
            style={{
              // flex: 1,
              position: "absolute",
              transform: [{ translateY: 20 }],
              borderWidth: 1,
              borderColor: "red",
              backgroundColor: "blue",
              flexGrow: 0,
              opacity: 0.5,
              // minWidth: 100,
            }}
          >
            <Text
              numberOfLines={1}
              style={[
                // this.formatStyle(),
                // ...styleArray,
                {
                  // minWidth: this.context.sizes.giant,
                  width: "auto",
                },
              ]}
              // onLayout={(e) => {
              //   console.log("onlayout", e.nativeEvent.layout.width);
              //   this.setState({ width: e.nativeEvent.layout.width });
              // }}
            >
              {stringVal}
            </Text>
          </View>
        )}
      </View>
    );
  }

  formatStyle = () => {
    let {
      bold,
      medium,
      light,
      hidden,
      style,
      underline,
      italic,
      strike,
      button,
      selectedButton,
    } = this.props;
    let defaultStyle = {
      ...this.context.styleSheet.input,
      color: this.context.colors.foreground,
      // fontSize: 15,
      // minHeight: 15,
      // fontFamily: 'regType',
    };

    if (underline) defaultStyle.textDecorationLine = "underline";
    if (hidden) defaultStyle.height = 0;
    if (italic) defaultStyle.fontStyle = "italic";
    if (bold) defaultStyle.fontWeight = "bold";
    if (light) defaultStyle.fontWeight = "100";
    if (strike) defaultStyle.textDecorationLine = "line-through";

    let lineHeightSet = false;
    if (style && Array.isArray(style)) {
      for (let sty of style) {
        if (sty && sty.fontSize && !sty.lineHeight) {
          defaultStyle.lineHeight = sty.fontSize * 1.5;
          lineHeightSet = true;
        }
      }
    } else if (style && style.fontSize && !style.lineHeight) {
      defaultStyle.lineHeight = style.fontSize * 1.5;
      lineHeightSet = false;
    }
    if (!lineHeightSet) {
      defaultStyle.lineHeight = this.context.sizes.default * 1.5;
    }

    if (button || selectedButton) {
      defaultStyle = {
        ...defaultStyle,
        padding: this.context.sizes.base,
        borderRadius: this.context.sizes.borderRadius,
        backgroundColor: this.context.colors.fill,
        marginRight: this.context.sizes.base,
      };
    }
    if (selectedButton) {
      defaultStyle = {
        ...defaultStyle,
        backgroundColor: this.context.colors.trim,
      };
    }

    return defaultStyle;
  };

  handleKeyPress = (event, stringVal) => {
    let cont = keyboardHelpers.globalListener(event);
    if (!cont) {
      event.stopPropagation();
      event.preventDefault();
      return false;
    }

    if (this.props.autoHeight) this.applyAutoHeight();
    if (this.props.autoWidth) this.applyAutoWidth();
    if (!!this.props.onKeyPress) {
      this.props.onKeyPress(event);
      return;
    }
    let modifiers = [];
    if (event.metaKey) modifiers.push("meta");
    if (event.shiftKey) modifiers.push("shift");
    if (event.altKey) modifiers.push("alt");
    if (event.ctrlKey) modifiers.push("ctrl");

    let key = event.nativeEvent.key;
    // console.log("textinput keypress:", event, key, modifiers);

    let triggerKey = false;
    // 13 == enter
    // 9 == tab
    if (key == "Tab") {
      if (event.shiftKey) {
        if (this.props.onShiftTab) {
          event.preventDefault();
          this.props.onShiftTab();
        }
      } else {
        if (this.props.onTab) {
          event.preventDefault();
          this.props.onTab();
        }
      }
    } else if (key == "k" && event.metaKey) {
      if (this.props.onMetaK) {
        event.preventDefault();
        this.props.onMetaK();
      }
    } else if (key == "Enter") {
      console.log("enter");
      if (event.metaKey) {
        if (event.shiftKey && this.props.onMetaShiftEnter) {
          event.preventDefault();
          this.props.onMetaShiftEnter();
        } else if (this.props.handleComplete) {
          event.preventDefault();
          this.props.handleComplete();
        } else if (this.props.onMetaEnter) {
          event.preventDefault();
          this.props.onMetaEnter();
        }
      } else if (event.shiftKey) {
        if (this.props.onShiftEnter) {
          event.preventDefault();
          this.props.onShiftEnter();
        }
      } else if (event.altKey) {
        if (this.props.onAltEnter) {
          event.preventDefault();
          this.props.onAltEnter();
        }
      } else {
        if (this.props.handleEnter) {
          event.preventDefault();
          this.props.handleEnter();
        }
        if (this.props.onEnter) {
          event.preventDefault();
          this.props.onEnter();
        }
      }
    } else if (key == "Backspace") {
      console.log("backspace");
      if (event.metaKey && !!this.props.onMetaBackspace) {
        this.props.onMetaBackspace();
      } else if (event.metaKey && !!this.props.onDelete) {
        this.props.onDelete({ shiftKey: event.shiftKey });
      }

      // if(item.text == ''){
      // this.handleDeleteItem(item)
      // }
    } else if (key == "Delete") {
      console.log("delete");
      // if(item.text == ''){
      // this.handleDeleteItem(item)
      // }
    } else if (key == "Escape") {
      console.log("escape");
      if (this.props.onEscape) this.props.onEscape();
      else if (this.props.onCancel) this.props.onCancel();
      else this.ref.blur();
      // this.setState({ query: "" });
    } else if (key == "ArrowUp") {
      // event.preventDefault();
      console.log(key, event);
      if (
        event.metaKey &&
        event.ctrlKey &&
        event.shiftKey &&
        !!this.props.onMetaCtrlShiftUp
      )
        this.props.onMetaCtrlShiftUp();
      else if (event.metaKey && event.altKey && event.shiftKey) {
        this.props.onMetaAltShiftArrow && this.props.onMetaAltShiftArrow("up");
      } else if (
        event.metaKey &&
        event.shiftKey &&
        !!this.props.onMetaShiftArrow
      )
        this.props.onMetaShiftArrow("up");
      else if (event.metaKey && event.ctrlKey)
        this.props.metaCtrlUp && this.props.metaCtrlUp();
      else if (event.ctrlKey && event.altKey)
        this.props.ctrlAltUp && this.props.ctrlAltUp();
      else if (event.metaKey && !!this.props.onMetaUp) this.props.onMetaUp();
      else if (event.altKey && !!this.props.onAltUp) this.props.onAltUp();
      else if (event.altKey)
        this.props.focusPreviousJump && this.props.focusPreviousJump();
      else if (this.props.onNatUp) this.props.onNatUp(event);
      else if (this.props.focusPrevious && this.liveCaretPos() == 0)
        this.props.focusPrevious();
      else {
        // handle naturally, don't preventDefault
        return;
      }
      event.preventDefault();
    } else if (key == "ArrowDown") {
      // event.preventDefault();
      if (event.metaKey && event.altKey && event.shiftKey)
        this.props.onMetaAltShiftArrow &&
          this.props.onMetaAltShiftArrow("down");
      else if (event.metaKey && event.ctrlKey && event.shiftKey)
        this.props.onMetaCtrlShiftDown && this.props.onMetaCtrlShiftDown();
      else if (event.metaKey && event.ctrlKey)
        this.props.metaCtrlDown && this.props.metaCtrlDown();
      else if (event.metaKey && !!this.props.onMetaDown)
        this.props.onMetaDown();
      else if (event.altKey && !!this.props.onAltDown) this.props.onAltDown();
      else if (event.altKey)
        this.props.focusNextJump && this.props.focusNextJump();
      else if (this.props.onNatDown) this.props.onNatDown(event);
      else if (
        this.props.focusNext &&
        (!this.stringVal?.length ||
          this.liveCaretPos() >= this.stringVal?.length)
      )
        this.props.focusNext();
      else {
        // handle naturally, don't preventDefault
        return;
      }
      event.preventDefault();
    } else if (key == "ArrowLeft") {
      if (event.metaKey && event.altKey && event.shiftKey)
        this.props.onMetaAltShiftArrow &&
          this.props.onMetaAltShiftArrow("left");
      else if (event.metaKey && !!this.props.onMetaLeft) {
        let result = this.props.onMetaLeft && this.props.onMetaLeft(event);
        // Only prevent default if handler returns true (or doesn't return false)
        if (result !== false) {
          event.preventDefault();
        }
      } else if (event.altKey && !!this.props.onAltLeft) {
        let result = this.props.onAltLeft && this.props.onAltLeft(event);
        // Only prevent default if handler returns true (or doesn't return false)
        if (result !== false) {
          event.preventDefault();
        }
      }
    } else if (key == "ArrowRight") {
      if (event.metaKey && event.altKey && event.shiftKey)
        this.props.onMetaAltShiftArrow &&
          this.props.onMetaAltShiftArrow("right");
      else if (
        event.metaKey &&
        event.ctrlKey &&
        event.shiftKey &&
        !!this.props.onMetaCtrlShiftRight
      ) {
        event.preventDefault();
        this.props.onMetaCtrlShiftRight();
      } else if (event.altKey && !!this.props.onAltRight) {
        let result = this.props.onAltRight && this.props.onAltRight(event);
        // Only prevent default if handler returns true (or doesn't return false)
        if (result !== false) {
          event.preventDefault();
        }
      } else if (
        event.metaKey &&
        event.shiftKey &&
        !!this.props.onMetaShiftRight
      ) {
        event.preventDefault();
        this.props.onMetaShiftRight();
      } else if (
        event.metaKey &&
        event.shiftKey &&
        !!this.props.onMetaShiftArrow
      ) {
        event.preventDefault();
        this.props.onMetaShiftArrow("right");
      } else if (
        event.metaKey &&
        event.ctrlKey &&
        !!this.props.onMetaCtrlRight
      ) {
        event.preventDefault();
        this.props.onMetaCtrlRight();
      } else if (event.metaKey && !!this.props.onMetaRight) {
        let result = this.props.onMetaRight && this.props.onMetaRight(event);
        // Only prevent default if handler returns true (or doesn't return false)
        if (result !== false) {
          event.preventDefault();
        }
      }
    } else if (key == "d") {
      if (event.metaKey && event.shiftKey && !!this.props.onMetaShiftD) {
        event.preventDefault();
        this.props.onMetaShiftD();
      } else if (event.metaKey && !!this.props.onMetaD) {
        event.preventDefault();
        this.props.onMetaD();
      }
    } else if (key == "n" || key == "N") {
      if (event.metaKey && event.shiftKey && !!this.props.onMetaShiftN) {
        event.preventDefault();
        this.props.onMetaShiftN();
      }
    }

    // ArrowUp
    // ArrowDown
    // ArrowLeft
    // ArrowRight
  };

  applyAutoHeight = (eventHeight = null) => {
    let maxHeight = this.props.maxHeight || this.props.style?.maxHeight;
    // console.log("-----scrollheight: ", eventHeight, this.ref?.scrollHeight);
    let scrollHeight = eventHeight || this.ref?.scrollHeight;
    if (scrollHeight) {
      let height = scrollHeight;
      if (!!maxHeight) {
        // height = Math.min(maxHeight, scrollHeight);
      }
      this.setState({ height });
      this.props.onChangeHeight && this.props.onChangeHeight(height);
    } else {
      // console.log("no scrollHeight ref", this, this.ref, this.ref?.textInput);
    }
    // this.ref?.measure((x, y, width, height, pageX, pageY) => {
    // console.log("measured", height);
    //   console.log(`first-- w:${width}, h:${height}, px:${pageX}, py:${pageY}`);
    // });
  };

  applyAutoWidth = () => {
    // console.log("scrollwidth: ", this.ref?.scrollWidth);
    // if (!!this.ref?.scrollWidth) {
    //   this.setState({ width: this.ref.scrollWidth });
    // }
    this.shadowRef?.measure((x, y, width, height) => {
      console.log("shadowRef", width);
      this.setState({ width });
      // this.setCaret();
    });
  };

  // current caret position, read live from the DOM on web — state.caretPos
  // only refreshes on keyup, so it's stale right after a mouse click
  liveCaretPos = () => {
    if (ENV.WEB && this.ref && this.ref.selectionStart != null) {
      return this.ref.selectionStart;
    }
    if (this.state.nativeSelection?.start != null) {
      return this.state.nativeSelection.start;
    }
    return this.state.caretPos || 0;
  };

  setCaret = async (updateSelection = true, setCaretPos = 0) => {
    // if (!ENV.WEB) return;
    let text = this.props.children;
    let { nativeSelection } = this.state;
    await new Promise((r) => setTimeout(r, 0));
    let selection = ENV.WEB
      ? [this.ref?.selectionStart, this.ref?.selectionEnd]
      : [nativeSelection.start || 0, nativeSelection.end || null];
    // console.log("setting carret");
    let caretPos = selection[0] || setCaretPos;
    this.setState({ caretPos });
    this.props.onSetCaret && this.props.onSetCaret(caretPos);
    return;

    let shadowText = text.slice(0, caretPos);
    // if we are in the whitespace at the end of the line
    // include the next word
    // if (shadowText.endsWith(" ")) {
    // shadowText = shadowText.replace(/.$/, "-");
    let nextWord = text.slice(caretPos).split(" ")[0] || "";
    shadowText += `${nextWord}`;
    // }
    // this.setState({ caretPos, shadowText });
    // console.log("caretpos", caretPos);
    this.setState({ caretPos, shadowText, fullShadowText: text });

    let caretLine = 1;
    this.shadowRef?.measure(async (x, y, width, height) => {
      let lineHeight = this.context.sizes.default * 1.6;
      caretLine = Math.floor(height / lineHeight);
      // console.error(caretLine);
      // console.log("currentLine", caretLine, caretPos);
      await this.setState({ caretLine });
      // console.log(caretLine, shadowText);
    });
    // this.setState({ caretPos, caretLine });

    if (updateSelection) {
      this.setState({ selection });
      if (selection[0] != undefined && selection[1] != undefined) {
        let query = text.slice(selection[0], selection[1]);
        query = query.trim();
        this.setState({ query });

        let startingIndex = this.findStartingIndex(
          this.props.children,
        ).caretPos;
        if (
          selection[0] <= startingIndex &&
          selection[1] > selection[0] &&
          selection[1] == text.length
        ) {
          // this.selectionTimeout = setTimeout(() => {
          // this.stopEditing();
          this.props.toggleSelected && this.props.toggleSelected(true);
          // }, 900);
        } else {
          !!this.selectionTimeout && clearTimeout(this.selectionTimeout);
          this.props.toggleSelected && this.props.toggleSelected(false);
        }
      }
    }
  };
  getNativeId = () => {
    let id = undefined;
    if (ENV.WEB) {
      let url = window.location.href;
      if (this.props.globalSearch) id = `global-search-${url}`;
      else if (this.props.defaultFocus) id = `default-focus-${url}`;
    }
    return id;
  };
}
